export default __webpack_public_path__ + "8ad4e4299ef5e377d2ef00ba5c94c44c.jpg";